import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../ui/dialog';
import { Button } from '../../ui/button';
import { Users, Clock, UsersRound } from 'lucide-react';
import { formatTime } from './utils';

/**
 * Quick-action dialog shown when the admin clicks an open/closed slot on
 * the calendar. Offers three shortcuts: create a walk-in booking, block
 * the slot for coaching, or spin up a new small-group session pinned to
 * this lane/time.
 */
export const SlotModal = ({
  open,
  onOpenChange,
  selectedSlot,
  lanes,
  onQuickBooking,
  onQuickBlock,
  onQuickSmallGroup,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="sm:max-w-sm max-h-[90vh] overflow-y-auto">
      <DialogHeader>
        <DialogTitle>
          {selectedSlot && `${lanes.find((l) => l.id === selectedSlot.laneId)?.name} - ${formatTime(selectedSlot?.timeSlot || '')}`}
        </DialogTitle>
      </DialogHeader>
      <div className="py-4">
        {selectedSlot?.isClosed && (
          <div className="mb-4 p-3 bg-amber-50 border border-amber-200 rounded-lg">
            <p className="text-sm text-amber-700 font-medium">⚠️ Outside Business Hours</p>
            <p className="text-xs text-amber-600 mt-1">
              This slot is outside normal business hours. Creating a booking here will override the schedule.
            </p>
          </div>
        )}
        <p className="text-sm text-slate-600 mb-4">What would you like to do with this slot?</p>
        <div className="flex flex-col gap-2">
          <Button onClick={onQuickBooking} className="bg-green-500 hover:bg-green-600 w-full" data-testid="slot-quick-booking-btn">
            <Users className="h-4 w-4 mr-2" />
            {selectedSlot?.isClosed ? 'Override & Book (Walk-in)' : 'Create Booking (Walk-in)'}
          </Button>
          <Button onClick={onQuickBlock} variant="outline" className="border-red-300 text-red-600 hover:bg-red-50 w-full" data-testid="slot-quick-block-btn">
            <Clock className="h-4 w-4 mr-2" />
            Block for Coaching
          </Button>
          <Button
            onClick={onQuickSmallGroup}
            variant="outline"
            className="border-violet-300 text-violet-700 hover:bg-violet-50 w-full"
            data-testid="slot-quick-small-group-btn"
          >
            <UsersRound className="h-4 w-4 mr-2" />
            Create Small Group Session
          </Button>
        </div>
      </div>
    </DialogContent>
  </Dialog>
);

export default SlotModal;
